import {combineReducers} from 'redux';
import {emptyReducer} from 'common/utils/reducers';
import data from './dataReducer';

export default combineReducers({
  views: emptyReducer,
  data,
});
